export default "__VITE_ASSET__QTtSYTNg__"